import React from 'react'
import { imagePath } from 'frontend_core/dist/helpers/image'
import { defaultLocale } from 'server/i18n'
import GlobalStyle from 'styles'

export default function BillingLayout(props) {
  const { children, config } = props
  const title = i18n.t(props.title || 'server.shared.default_title')
  const siteName = i18n.t('server.shared.default_site_name')
  const description = i18n.t(
    props.description || 'server.shared.default_description',
  )
  const url = props.url || ''
  const image = props.image || imagePath('stay/common/ogimage.png')
  const bodyClassNames = ['site-business']
  if (props.bodyClassName) bodyClassNames.push(props.bodyClassName)

  const meta = {
    title: `${title} | ${siteName}`,
    description,
    og: {
      title,
      description,
      url,
      image,
      siteName,
      type: 'website',
      locale: defaultLocale,
    },
    twitter: {
      title,
      description,
      url,
      image: { src: image },
      card: '',
      site: '@spacemarketjp',
      creator: '@spacemarketjp',
    },
  }

  function renderAll(element) {
    return (
      <html>
        <head>
          <meta charSet="utf-8" />
          <meta name="copyright" content="&copy; Space Market" />
          <link rel="stylesheet" href={manifest['print/main.css']} />
          <link
            href="https://use.fontawesome.com/releases/v5.0.10/css/all.css"
            rel="stylesheet"
          />
          <script
            src="https://browser.sentry-cdn.com/4.5.4/bundle.min.js"
            crossOrigin="anonymous"
          />
        </head>
        <body className="page_print">
          <div id="js-root">{renderRoot()}</div>
          <GlobalStyle />
        </body>
      </html>
    )
  }

  function renderRoot() {
    return <div>{children}</div>
  }
  return config.SSR ? renderAll() : renderRoot()
}
